export const getEnv = () => process.env;

export const isFeatureEnabled = (feature) => {
  const env = getEnv();

  return env[feature] === 'true';
};

export const FEATURE_FLAGS = {
  ENTRA: 'REACT_APP_FEATURE_ENTRA_ENABLED',
  INVENTORY_PAGE: 'REACT_APP_FEATURE_INVENTORY_PAGE_ENABLED'
};
